import { render, staticRenderFns } from "./CategoryAdd.vue?vue&type=template&id=67582e8f&scoped=true&"
import script from "./CategoryAdd.vue?vue&type=script&lang=js&"
export * from "./CategoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAdd.vue?vue&type=style&index=0&id=67582e8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67582e8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VRow,VSpacer,VTextarea})
